import * as builder from './project/index'

export const reducers = builder.defaultReducers
export const features = builder.defaultFeatures
export const api = builder.api
export const initialState = builder.defaultInitialState

export default api


// WEBPACK FOOTER //
// ./src/config-builders/project.js